<template>
  <b-container class="reset-password-container" align-v="center">
    <GlobalSpinner v-if="showSpinner" />
    <b-row align-h="center" class="reset-password-center-container" align-v="center">

      <!-- Card -->
      <b-card class="reset-password-card"
              header-tag="header"
              footer-tag="footer">

        <!-- Header -->
        <div slot="header"
             class="row">
          <icon class="col-12 mb-3"
                name="key"
                scale="3" />
          <div class="col-12 reset-password-card-title"><h3>{{ msg }}</h3></div>
        </div>
        <!-- Form Login -->
        <b-form @submit="submitNewPassword"
                id="app-reset-password-form">

          <!-- Password -->
          <b-form-group id="passwordGroup"
                        label="Votre nouveau mot de passe"
                        label-for="password">
            <b-form-input id="password"
                          type="password"
                          v-model="form.password"
                          required
                          placeholder="Entrez votre mot de passe">
            </b-form-input>
          </b-form-group>
          <b-form-group id="passwordGroup"
                        label="Confirmation du nouveau mot de passe"
                        label-for="passwordConfirm">
            <b-form-input id="passwordConfirm"
                          type="password"
                          v-model="passwordConfirm"
                          required
                          placeholder="Entrez votre mot de passe">
            </b-form-input>

            <!-- Alert -->
            <b-alert class="reset-password-alert"
                     :variant="alert.variant"
                     :show="alert.show">
              {{ alert.content }}
            </b-alert>
          </b-form-group>
        </b-form>

        <!-- Footer -->
        <em slot="footer">

          <b-row>
            <b-col>
              <!-- Submit login form -->
              <b-button form="app-reset-password-form" class="reset-password-submit"
                        type="submit"
                        variant="primary">
                Envoyer
              </b-button>
            </b-col>

            <b-col>
              <router-link class="btn btn-info" :to="{ name: 'login' }">Annuler</router-link>
            </b-col>
          </b-row>
        </em>
      </b-card>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'ResetPassword',
  data() {
    return {
      msg: 'Changement de mot de passe',
      form: {
        password: '',
        token: '',
      },
      passwordConfirm: '',
      alert: {
        show: false,
        content: '',
        variant: '',
      },
      showSpinner: false,
    };
  },
  mounted() {
    this.form.token = this.$route.params.token;
  },
  methods: {
    submitNewPassword(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.form.password !== this.passwordConfirm) {
        this.toggleAlert(true, 'Les deux mots de passe doivent être identiques.', 'danger');
        return;
      }
      this.showSpinner = true;
      this.toggleAlert(false);
      axios.post('users/reset/password', this.form)
        .then((response) => {
          this.toggleAlert(true, 'Opération réussie, vous pouvez dès maintenant vous connecter avec votre nouveau mot de passe.', 'success');
        }, () => {
          this.toggleAlert(true, 'Une erreur s\'est produite. Le délais du lien de confirmation est peut être dépassé.', 'danger');
        })
        .finally(() => {
          this.form.password = '';
          this.form.token = '';
          this.passwordConfirm = '';
          this.showSpinner = false;
          setTimeout(() => {
            this.$router.push('/logout');
          }, 3000);
        });
    },
    toggleAlert(show, content, variant) {
      this.alert.variant = variant !== null ? variant : '';
      this.alert.content = content !== null ? content : '';
      this.alert.show = show !== null ? show : !this.alert.show;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .reset-password-container {
    width: 100%;
    max-width: 100% !important;
    height: 100%;
    padding: 0 !important;
    margin: 0 !important;

    .reset-password-center-container {
      width: 100%;
      height: 100%;
      margin: 0 !important;

      @media all and (max-height: 768px){
        align-items: flex-start !important;
      }
    }

    .reset-password-card {
      width: 50%;
      max-width: 400px;
      margin-bottom: 15px;
      margin-top: 15px;


      @media all and (max-height: 768px){
        margin-left: auto !important;
        margin-right: auto !important;
      }
      @media all and (max-width: 768px){
        width: 100%;
      }

      .reset-password-card-title {
        text-align: center;
      }
    }

    .reset-password-alert {
      margin-top: 10px;
    }

    .reset-password-submit {
      display: block;
      width: 100%;
      margin-bottom: 5px;
    }
  }

  .btn-info {
    font-style: initial;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/security/ResetPassword.vue